import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {map} from 'lit/directives/map.js';
import {range} from 'lit/directives/range.js';
import {msg} from '@lit/localize';

import store from '../../../store';
import {
	selectIomoBracket,
	selectIomoDesignIsPole, selectIomoHeads,
	selectIomoNumberOfHeads, selectIomoPoleHeight,
} from '../../iomoSelectors';

@customElement('iomo-specsheet-drill-table')
export class IomoSpecsheetDrillTable extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				width: 100%;
				container-type: inline-size;
			}
			.headline {
				font: var(--font-specsheet-print-small-bold);
				font-weight: bold;
				font-size: 1.4cqw;
				padding: 0.7cqw 0 0.7cqw 0;
			}
			.index {
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: black;
				font-size: 1.2cqw;
				color: white;
				height: 2cqw;
				width: 2cqw;
				border-radius: 1cqw;
			}
			table {
				border-collapse: collapse;
				width: 100%;
			}
			th {
				font: var(--font-specsheet-print-small-bold);
				font-weight: bold;
				font-size: 1.4cqw;
				text-align: left;
				padding: 0.7cqw 0.5cqw 0.7cqw 0;
				border-bottom: 1px solid #c6c6c6;
			}
			td {
				font: var(--font-specsheet-print-small-text);
				font-weight: bold;
				font-size: 1.4cqw;
				text-align: left;
				padding: 0.7cqw 0.5cqw 0.7cqw 0;
				border-bottom: 1px solid #c6c6c6;
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	connectedCallback() {
		super.connectedCallback();
	}
	stateChanged(state) {
		this.state = state;
		this.numberOfHeads = selectIomoNumberOfHeads(state);
		this.heads = selectIomoHeads(state).filter(h => h.active);
	}

	getHeadRow(instance) {
		const height = Math.floor(this.heads[instance].height  * 1000);
		const la = Math.floor(this.heads[instance].la  * 1000);
		const angle = this.heads[instance].angle;

		return html`
			<tr class="row">
				<td><span class="index">${instance + 1}</span></td>
				<td>${la} mm</td>
				<td>${angle}°</td>
		`;
	}
	render() {
		const s = store.getState();
		if (!selectIomoDesignIsPole(s)) return null;

		return html`
			<div class="headline">${msg('Drill Measurements')}</div>
			<table class="table heads">
				<tr class="headerRow">
					<th>${msg('number')}</th>
					<th>LA (${msg('from top')})</th>
					<th>Z (${msg('angle from door')})</th>
				</tr>
				${map(range(this.numberOfHeads), (i) => this.getHeadRow(i))}
			</table>
        `;
	}
}
